import defaultTransition from '../transitions/default';

export default [
    defaultTransition
];
